import { Box, Card, GridSize, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Breakpoint } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { ETheme } from "../enums/user/ETheme";
import { formatDate } from "../functions/formatDate";
import { IUser } from "../interfaces/user/IUser";
import { darkPalette, lightPalette } from "../mui/palettes";

export type ResponsiveStyleValue<T> =
  | T
  | Array<T | null>
  | {
      [key in Breakpoint]?: T | null;
    };

interface IProps {
  title: string;
  getTitle: (title: string) => string;
  getIcon: (title: string) => React.JSX.Element;
  getValue: (title: string) => string;
  size?: ResponsiveStyleValue<GridSize> | undefined;
  onClick?: () => void;
  isSelected?: boolean;
}
const StatisticCard = ({
  isSelected,
  onClick,
  title,
  getValue,
  getTitle,
  getIcon,
  size = {
    xs: 12,
    md: 6,
    lg: 4,
  },
}: IProps) => {
  const { t } = useTranslation();
  const company = useSelector((state: RootState) => state?.companySettings);
  const { theme } = useSelector(
    (state: RootState) => state?.auth?.userData,
  ) as IUser;
  return (
    <Grid
      size={size}
      sx={{
        cursor: onClick ? "pointer" : undefined,
      }}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      <Card
        sx={{
          pb: "10px",
          borderColor: isSelected ? company?.primaryColor : undefined,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              padding: "10px",
              backgroundColor: `${company?.primaryColor}0D`,
              borderRadius: "10px",
              color: "var(--primaryColor)",
            }}
          >
            {getIcon(title)}
          </Box>
          <Typography sx={{ marginLeft: "10px", fontWeight: 500 }}>
            {getTitle(title)}
          </Typography>
        </Box>
        <Typography
          variant={"h5"}
          fontWeight={"600"}
          sx={{ marginTop: "10px", marginBottom: "10px" }}
        >
          {getValue(title)}
        </Typography>
        <Box
          sx={{
            paddingTop: "10px",
            borderTop: `1px solid ${theme === ETheme.LIGHT ? lightPalette.primary.light : darkPalette.background.light}`,
          }}
        >
          <Typography
            variant={"subtitle2"}
            color={lightPalette.text.gray}
            sx={{
              fontWeight: "300",
            }}
          >
            {t("general.updated")}:{" "}
            {formatDate(new Date()?.toISOString(), "MMMM D, YYYY")}
          </Typography>
        </Box>
      </Card>
    </Grid>
  );
};

export default StatisticCard;
